import { mobileMainContainer, mobileContainerPaper } from '../../../styles/shared/mobile';

export const mobileCourseMainContainer = {
    fontFamily: mobileMainContainer.fontFamily,
    marginTop: '57px'
}
export const mobileContentContainerPaperStyle = {
    borderRadius: '20px'
}

export const mobileContentContainerPaperDivStyle = {
    // width: '90%',
    // marginLeft: '5%',
    // marginRight: '5%',
    // marginTop: '50px',
    // marginBottom: '50px'
}


export const mobileImageContainerStyle= {
    textAlign: 'center',
    display: 'inline-block',
    width: '333px%',
    marginTop: 25,
    marginBottom: 25,
    marginRight: 25
}

export const mobileWelcomeTextContainerStyle= {
    // display: 'inline-block',
    // width: '60%',
    // verticalAlign: 'top',
    // marginLeft: '50px'

}



// WEBPACK FOOTER //
// ./src/components/course/styles/mobile.js